import React from "react";
import { useAudio } from "../../providers/AudioProvider";

export const ChatControls: React.FC = () => {
  const { playResponseOutloud, setPlayResponseOutloud } = useAudio();
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center px-3 sm:px-4 sm:py-3 gap-3 sm:gap-0 flex-shrink-0 pb-2">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <div className="flex flex-row items-center space-x-2">
          <input
            type="checkbox"
            id="play-responses-outloud"
            data-trust-trigger="play-responses"
            checked={playResponseOutloud}
            onChange={(e) => {
              const checked = e.target.checked;
              setPlayResponseOutloud(checked);
            }}
            className="w-4 h-4"
          />
          <label
            htmlFor="play-responses-outloud"
            className="text-xs sm:text-sm text-gray-600"
          >
            Play responses aloud
          </label>
        </div>
      </div>
    </div>
  );
};
